//@ts-check
import React from "react"
import useStyles from "./enter-eth-address.styles"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import { isValidAddress } from "src/utils/is-valid-address"
import Link from "@material-ui/core/Link"
import { Input } from "../input"
import ConfirmExtractCode from "./confirm-extract-code"
import useIsWide from "../../utils/use-is-wide"

export default function EnterMainnetAddress({
  inputAddress,
  mainnetAddressChangeHandler,
  loadingSolidityState,
  onExtractFromMainnet,
  mainnetRequestState,
  isInPopover,
}) {
  const { t } = useTranslation()
  const classes = useStyles({})

  const isWide = useIsWide()

  return (
    <>
      <div className={classes.addressSection}>
        <div className={classes.wrapper}>
          <div className={clsx({ [classes.addressForm]: isWide })}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Input
                id="mainnetAddressField"
                labelBackground={isInPopover ? "#ffffff" : "#f6f6fa"}
                isUpdateOnChange // To support chage the button state while typing
                label="Mainnet Address"
                value={inputAddress}
                onChange={mainnetAddressChangeHandler}
                error={inputAddress && !isValidAddress(inputAddress)}
                placeholder="0x..."
                maxLength={42}
                width={"100%"}
                wrapperWidth={"100%"}
              />
            </div>
            {(inputAddress && !isValidAddress(inputAddress)) ? (
              <div style={{ color: "red", paddingLeft: "110px" }}>
                Invalid address
              </div>
            ) : null}
          </div>
          <ConfirmExtractCode
            inputAddress={inputAddress}
            loadingSolidityState={loadingSolidityState}
            onExtractFromMainnet={onExtractFromMainnet}
            mainnetRequestState={mainnetRequestState}
          />
        </div>
      </div>
      <div
        className={clsx({
          [classes.poweredByNotice]: isWide,
          [classes.poweredByNotice_mobile]: !isWide,
        })}
      >
        {/*
          // @ts-ignore */}
        <Link
          to="http://etherscan.io"
          target="_blank"
          rel="noopener"
          className={classes.sourceText}
        >
          {t("source")}
        </Link>
      </div>
    </>
  )
}
